export default {
  methods: {
    toggleDisabled (val, object) {
      this.toggleBoolean(val, object, 'disabled', true)
    },
    toggleBoolean (val, object, property, invert) {
      if (this.fieldErrors) {
        this.$set(this.fieldErrors, property, [])
      }
      object[property] = invert ? !val : val
    }
  }
}
